import { AccountType } from 'src/utils/enums'

/**
 * Roles that get the simplified salesman-style project hub (list + detail +
 * inline editor) instead of the architect chrome.
 *
 * SOCIETY (company) sees the exact same hub as SALESMAN — only scoped to
 * every project owned by one of the company's salesmen, with the salesman's
 * name surfaced on each project. Hasura row-level permissions enforce the
 * scope server-side (SOCIETY mirrors the SALESMAN permission set, re-scoped
 * through `salesman.society_id`).
 */
export const isProjectHubRole = (
  accountType: string | null | undefined,
): boolean =>
  accountType === AccountType.SALESMAN || accountType === AccountType.SOCIETY
